import { ErrorLogComponent } from '@cian/error-log-component';
import { UiKitContextProvider } from '@cian/ui-kit/context';
import * as React from 'react';
import { Provider } from 'react-redux';

import { IApplicationContext } from '../../types/applicationContext';
import { TReduxStore } from '../../types/redux';
import { ApplicationContext } from '../../utils/applicationContext';
import { CookiesNotificationContainer } from '../CookiesNotificationContainer';
import { FeedbackFormContainer } from '../FeedbackFormContainer';
import { HeaderContainer } from '../HeaderContainer';
import { MergeNotificationContainer } from '../MergeNotificationContainer';

export interface IApplicationProps {
  context: IApplicationContext;
  reduxStore: TReduxStore;
}

export const Application: React.FC<IApplicationProps> = ({ reduxStore, context }) => {
  const {
    logger,
    custom: { initialDeviceType },
  } = context;

  return (
    <ErrorLogComponent logger={logger}>
      <ApplicationContext.Provider value={context}>
        <UiKitContextProvider deviceType={initialDeviceType || 'phone'}>
          <Provider store={reduxStore}>
            <MergeNotificationContainer />
            <CookiesNotificationContainer />
            <HeaderContainer />
            <FeedbackFormContainer />
          </Provider>
        </UiKitContextProvider>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};
